'use strict';

angular.module('app.services')
.factory('colaboradoresApi', colaboradoresApi);

colaboradoresApi.$inject = ['$resource', 'ConfigApp'];

function colaboradoresApi($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/colaboradores',
        {  }, {
            atendentesInicio: {
                method: 'GET',
                params: { canalDeAtendimentoId: '@canalDeAtendimentoId' },
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/colaboradores/atendentes_inicio'
            },
            atendentesFim: {
                method: 'GET',
                params: { canalDeAtendimentoId: '@canalDeAtendimentoId' },
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/colaboradores/atendentes_fim'
            }
        });
};



// WEBPACK FOOTER //
// ./src/services/colaboradores-api-service.js